import x from "./extends3.mjs";
import u from "./objectWithoutPropertiesLoose3.mjs";
import * as E from "react";
import { clsx as a } from "./clsx.mjs";
import { pickersSlideTransitionClasses as e, getPickersSlideTransitionUtilityClass as h } from "./pickersSlideTransitionClasses.mjs";
import { jsx as o } from "react/jsx-runtime";
import v from "./styled.mjs";
import A from "./TransitionGroup.mjs";
import $ from "./useThemeProps.mjs";
import g from "./useTheme.mjs";
import T from "./CSSTransition.mjs";
import C from "./composeClasses.mjs";
const L = ["children", "className", "reduceAnimations", "slideDirection", "transKey", "classes"], S = (i) => {
  const {
    classes: t,
    slideDirection: s
  } = i, n = {
    root: ["root"],
    exit: ["slideExit"],
    enterActive: ["slideEnterActive"],
    enter: [`slideEnter-${s}`],
    exitActive: [`slideExitActiveLeft-${s}`]
  };
  return C(n, h, t);
}, k = v(A, {
  name: "MuiPickersSlideTransition",
  slot: "Root",
  overridesResolver: (i, t) => [t.root, {
    [`.${e["slideEnter-left"]}`]: t["slideEnter-left"]
  }, {
    [`.${e["slideEnter-right"]}`]: t["slideEnter-right"]
  }, {
    [`.${e.slideEnterActive}`]: t.slideEnterActive
  }, {
    [`.${e.slideExit}`]: t.slideExit
  }, {
    [`.${e["slideExitActiveLeft-left"]}`]: t["slideExitActiveLeft-left"]
  }, {
    [`.${e["slideExitActiveLeft-right"]}`]: t["slideExitActiveLeft-right"]
  }]
})(({
  theme: i
}) => {
  const t = i.transitions.create("transform", {
    duration: i.transitions.duration.complex,
    easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
  });
  return {
    display: "block",
    position: "relative",
    overflowX: "hidden",
    "& > *": {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${e["slideEnter-left"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      zIndex: 1
    },
    [`& .${e["slideEnter-right"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      zIndex: 1
    },
    [`& .${e.slideEnterActive}`]: {
      transform: "translate(0%)",
      transition: t
    },
    [`& .${e.slideExit}`]: {
      transform: "translate(0%)"
    },
    [`& .${e["slideExitActiveLeft-left"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      transition: t,
      zIndex: 0
    },
    [`& .${e["slideExitActiveLeft-right"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      transition: t,
      zIndex: 0
    }
  };
});
function M(i) {
  const t = $({
    props: i,
    name: "MuiPickersSlideTransition"
  }), {
    children: s,
    className: n,
    reduceAnimations: c,
    transKey: d
    // extracting `classes` from `other`
  } = t, m = u(t, L), r = S(t), f = g();
  if (c)
    return /* @__PURE__ */ o("div", {
      className: a(r.root, n),
      children: s
    });
  const l = {
    exit: r.exit,
    enterActive: r.enterActive,
    enter: r.enter,
    exitActive: r.exitActive
  };
  return /* @__PURE__ */ o(k, {
    className: a(r.root, n),
    childFactory: (p) => /* @__PURE__ */ E.cloneElement(p, {
      classNames: l
    }),
    role: "presentation",
    children: /* @__PURE__ */ o(T, x({
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: f.transitions.duration.complex,
      classNames: l
    }, m, {
      children: s
    }), d)
  });
}
export {
  M as PickersSlideTransition
};
//# sourceMappingURL=PickersSlideTransition.mjs.map
